var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgScheduleFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Schedule") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/ScheduleFill",
    fill: "#6C7DBC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5238698,4.61699772 C19.4685975,4.61699772 20.2344506,5.38285084 20.2344506,6.32757855 L20.2344506,6.32757855 L20.2344506,19.3200812 C20.2344506,20.2648089 19.4685975,21.030662 18.5238698,21.030662 L18.5238698,21.030662 L5.47613024,21.030662 C4.53140253,21.030662 3.7655494,20.2648089 3.7655494,19.3200812 L3.7655494,19.3200812 L3.7655494,6.32757855 C3.7655494,5.38285084 4.53140253,4.61699772 5.47613024,4.61699772 L5.47613024,4.61699772 Z M15.4997062,14.1026261 L14.5299669,14.1026261 C13.8549562,14.1026261 13.3064147,14.6511676 13.3064147,15.3261783 L13.3064147,16.2959176 C13.3064147,16.9709283 13.8549562,17.5194698 14.5299669,17.5194698 L15.4997062,17.5194698 C16.1747169,17.5194698 16.7232584,16.9709283 16.7232584,16.2959176 L16.7232584,15.3261783 C16.7232584,14.6511676 16.1747169,14.1026261 15.4997062,14.1026261 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "8.72304123 2.969338 8.72304123 5.42727285 6.72304123 5.42727285 6.72304123 2.969338"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-6-Copy",
    points: "17.2769588 2.969338 17.2769588 5.42727285 15.2769588 5.42727285 15.2769588 2.969338"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgScheduleFill);
export default __webpack_public_path__ + "static/media/ScheduleFill.666a70111c7c6a2b5a06b926561169fb.svg";
export { ForwardRef as ReactComponent };